<template>
  <g fill-rule="nonzero">
    <path
      d="M9.72 4.09a.61.61 0 00-.47.4c-.03.1-.5 1.9-.5 1.95a1.77 1.77 0 002.18.26c.14-.09.32-.24.32-.27 0-.04-.48-1.87-.51-1.95a.62.62 0 00-.39-.37 1.62 1.62 0 00-.63-.02zM8.25 8.53a32.5 32.5 0 00-.48 1.56c-.05.25 0 .45.15.64.28.36.83.6 1.59.72.28.04.96.04 1.23 0 .78-.12 1.32-.37 1.6-.74a.66.66 0 00.15-.56l-.12-.43-.45-1.45c-.01 0-.03.01-.05.05-.19.36-.67.6-1.34.7-.26.03-.75.02-1-.03-.55-.1-.96-.33-1.13-.64a.69.69 0 00-.06-.1l-.1.28z"
    />
    <path
      d="M7.16 11.25c-.36.16-1.37.7-1.6.84-.4.24-.56.41-.56.6 0 .26.26.51 1.05 1.03.45.29 1.49 1 2 1.35.76.54 1.28.81 1.7.9.17.04.44.03.63-.02a5.7 5.7 0 001.71-.97 45.84 45.84 0 011.84-1.24c.4-.25.53-.34.7-.49.15-.13.3-.32.34-.43a.5.5 0 000-.31.83.83 0 00-.35-.36c-.1-.06-1.97-1-1.98-.99 0 .02.03.16.1.38.1.35.12.5.03.71-.05.13-.24.37-.37.48-.57.47-1.57.72-2.67.67a3.62 3.62 0 01-2.02-.61c-.26-.2-.4-.35-.48-.55a.53.53 0 01-.04-.26c0-.15.01-.22.12-.56.06-.2.07-.26.06-.26l-.2.09z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TrafficPlotIcon",
});
</script>
